<template>
  <b-card class="rounded-xl">
    <modal :show.sync="editModal" header-classes="bg-primary p-3">
      <h6 slot="header" class="modal-title text-white font-semibold pt-1">
        EDIT IMAGE ORDER
      </h6>
      <EditTagsDetail />
      <template slot="footer">
        <base-button type="primary">SAVE CHANGES</base-button>
        <base-button type="secondary" class="ml-auto" @click="editModal = false"
          >CLOSE</base-button
        >
      </template>
    </modal>
    <AddTagsSidebar
      :isSidebarActive="openAddBannerSidebar"
      @closeSidebar="toggleAddBannerSidebar"
    />

    <div class="flex justify-between items-center mobile-flexnone">
      <div>
        <h2 class="text-2xl font-semibold">List Of Channels</h2>

        <small class="text-muted"
          >Manage the channels of your community here.
        </small>
      </div>

      <div class="md:py-4 lg:py-4">
        <button
          type="button"
          class="btn btn-primary w-full md:mt-5 lg:mt-5 mt-3 py-3 text-white font-semibold flex justify-center"
          @click="handleCreateChanel"
        >
          <feather-icon
            svgClasses="w-5 h-5"
            icon="PlusIcon"
            class="mr-1"
          ></feather-icon
          >New Channel
        </button>

        <!-- <div class="my-6 border-b border-gray-400 " /> -->
      </div>
      <CreateChannelBar
        @closeModal="closeModal"
        :ChannelCreateSidebar="ChannelCreateSidebar"
      />
      <!-- <div class="mobile-mt4">
        <base-button type="warning" class="px-8" @click="addBanner">
          Add Channel
        </base-button>
      </div> -->
    </div>
    <!-- <b-input-group class="mt-12">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          min="0.00"
          placeholder="Enter Search...."
        ></b-form-input>

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
          >
            <feather-icon
              class=" cursor-pointer  mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group> -->
    <UsersTable ref="createChannel" />
  </b-card>
</template>
<script>
import "../../scss/Index.scss";
import TagsData from "./components/TagsData";
import EditTagsDetail from "./components/EditTagsDetail";
import AddTagsSidebar from "./components/AddTagsSidebar";
import { mapState } from "vuex";
import UsersTable from "./components/UsersTable";
import NewChannel from "./components/NewChannel.vue";
import CreateChannelBar from "./components/CreateChannelBar.vue";
export default {
  components: {
    EditTagsDetail,
    AddTagsSidebar,
    UsersTable,
    NewChannel,
    CreateChannelBar,
  },
  data() {
    return {
      TagsData,
      currentPage: 1,
      editModal: false,
      openAddBannerSidebar: false,
      ChannelCreateSidebar: false,
    };
  },
  methods: {
    handleCreateChanel() {
      this.ChannelCreateSidebar = !this.ChannelCreateSidebar;
    },
    addBanner() {
      this.toggleAddBannerSidebar(true);
    },
    toggleAddBannerSidebar(val = false) {
      this.openAddBannerSidebar = val;
    },
    closeModal() {
      this.ChannelCreateSidebar = false;
      this.$refs.createChannel.dataload();
    },
  },
};
</script>
